var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(-435 -138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2954",
    "data-name": "Rectangle 2954",
    transform: "translate(435 138)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search-interface-symbol",
    transform: "translate(435.923 138.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__4_",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    "data-name": "Group 4452",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M17.959,17.184l-3.292-3.34a8.175,8.175,0,0,0,2.185-5.555A8.357,8.357,0,0,0,8.429,0,8.356,8.356,0,0,0,.006,8.289a8.356,8.356,0,0,0,8.423,8.289,8.471,8.471,0,0,0,5.3-1.851l3.312,3.36a.655.655,0,0,0,.916,0A.631.631,0,0,0,17.959,17.184ZM8.429,15.3A7.071,7.071,0,0,1,1.3,8.289,7.071,7.071,0,0,1,8.429,1.275a7.071,7.071,0,0,1,7.127,7.014A7.071,7.071,0,0,1,8.429,15.3Z",
    transform: "translate(-0.006)",
    fill: "#9e9e9e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyGlass);
export default __webpack_public_path__ + "static/media/magnifyGlass.b7082cade10e36f5b51b53c968b957de.svg";
export { ForwardRef as ReactComponent };